define('shared/initializer/form/adapters/mixins/fields/ConfirmPassword',[
    'shared/lib/RSVP',
    '../../../constants'
], 
function(
    RSVP,
    constants
) {
    'use strict';

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var fieldConfirmPassword = me.items[constants.FIELD.CONFIRM_PASSWORD.toLowerCase()];
        var fieldPassword = me.items[constants.FIELD.MY_PASSWORD.toLowerCase()];
        if(fieldPassword == null){
            fieldPassword = me.items[constants.FIELD.NEW_PASSWORD.toLowerCase()];
        }

        if (fieldConfirmPassword != null && fieldPassword != null) {
            fieldConfirmPassword.validate = function(value, options){
                if (value != fieldPassword.$el.val()) {
                    return RSVP.reject(
                        fieldConfirmPassword.messages && fieldConfirmPassword.messages.invalid || 
                        (options && options.message) || 
                        null
                    );
                }
                else {
                    return RSVP.resolve();
                }
            };   
        }

        return RSVP.resolve();
    };

    return Ctor;
});
